import { insideItems } from "@/mocks/leakHome";

export default function InsideFeed() {
  return (
    <section id="inside" className="w-full bg-white py-10 md:py-14">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold tracking-widest text-red-500">
              <span className="inline-block h-2 w-2 rounded-full bg-red-500 animate-pulse"></span>
              INSIDER EXPRESS
            </p>
            <h2 className="mt-1 text-2xl font-black text-stone-800 md:text-3xl">内幕速递 · 抢先看</h2>
          </div>
          <a href="#feed" className="text-sm font-semibold text-red-600 hover:text-red-700">
            全部独家 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-7 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {insideItems.map((item) => (
            <a
              key={item.id}
              href="#feed"
              className="group overflow-hidden rounded-2xl border border-stone-100 bg-white transition hover:shadow-md hover:shadow-red-900/5"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} - 52爆料内幕`}
                  className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-red-600 px-3 py-1 text-xs font-bold text-white">
                  {item.kicker}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-bold leading-snug text-stone-800 group-hover:text-red-700">
                  {item.title}
                </h3>
                <p className="mt-3 flex items-center gap-1.5 text-xs font-medium text-stone-400">
                  <i className="ri-user-heart-line"></i> 来源 · {item.source}
                  <span className="ml-auto flex items-center gap-1 text-red-400">
                    看看去 <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
                  </span>
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}